import React from 'react';
import { BadgeEuro, MapPin, Star, Radio } from 'lucide-react';
import { whyChooseUs } from '../mockData';

const iconMap = {
  BadgeEuro: BadgeEuro,
  MapPin: MapPin,
  Star: Star,
  Radio: Radio
};

const About = () => {
  return (
    <section id="about" className="py-10 sm:py-16 bg-white">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden shadow-2xl bg-white border-2 border-gray-200">
              <img 
                src="https://customer-assets.emergentagent.com/job_corfu-rides/artifacts/qd0sw8uy_mercedes-benz-cla-class-color-161839-removebg-preview.png" 
                alt="Mercedes-Benz Luxury Vehicle"
                className="w-full h-full object-contain p-6"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              About <span className="text-blue-600">Golden Corfu Transfer</span>
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Welcome to Golden Corfu Transfer, your premier choice for private transportation services across the stunning island of Corfu. With years of experience serving tourists and locals alike, we've built our reputation on reliability, comfort, and exceptional service.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed">
              Our team of professional drivers knows every corner of this beautiful island and is dedicated to making your journey as smooth and enjoyable as possible. Whether you're arriving at the airport, heading to the port, or exploring Corfu's hidden gems, we're here to serve you 24/7 with premium vehicles and unmatched hospitality.
            </p>

            {/* Why Choose Us Cards */}
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              {whyChooseUs.map((item, index) => {
                const IconComponent = iconMap[item.icon];
                return (
                  <div key={index} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-3 sm:p-5 border border-blue-100">
                    <div className="flex items-start space-x-2 sm:space-x-3">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                        <IconComponent className="text-white" size={16} />
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-0.5 sm:mb-1 text-sm sm:text-base">{item.title}</h4>
                        <p className="text-xs sm:text-sm text-gray-600">{item.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;